module.exports = __webpack_public_path__ + "img/4.a3954217.jpg";